import React from "react";
import { Link } from "react-router-dom";

const Forbidden: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-red-600">403 – Forbidden</h1>

        <p className="text-gray-600">
          You do not have permission to access this page.
        </p>

        {/* Tenant-safe: routes to "/" which resolves via FallbackRedirect */}
        <Link
          to="/"
          className="inline-block px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
        >
          Go to Login
        </Link>
      </div>
    </div>
  );
};

export default Forbidden;
